// extracted by mini-css-extract-plugin
module.exports = {"container":"RegenerateCollageOption_container__3c_MD"};